<!--
{
  "type": "content-creator",
  "data": {
    "ccid": "asdasdaxasdas-asdadasds-xxxx"
  }
}
-->
<template>
  <div>
    <content-creator
      :settings="getBlobContents(`constructed-page--${pageid}-cc--${slice.data.ccid}`)"
      :permissions="contentCreatorPermissions"
      :is-visible="editContentCreator"
      :filestore="websitefilestore"
      :name="`constructed-page--${pageid}-cc--${slice.data.ccid}`"
      @updateBlob="(data) => saveBlob(`constructed-page--${pageid}-cc--${slice.data.ccid}`, data)"
    />
  </div>
</template>

<script>
import contentCreatorMixin from 'src/app/content-creator-mixin'

export default {
  name: 'slice-type-content-creator',
  mixins: [
    contentCreatorMixin
  ],
  props: {
    slice: {
      type: Object,
      required: false,
      default: function() {
        return {}
      }
    },
    pageid: {
      type: String,
      required: true
    }
  }
}
</script>

<style scoped lang="scss">
  @import '~@scss/custom.scss';
</style>
